import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconContentAdd from '@material-ui/icons/Add'
import IconCancel from '@material-ui/icons/Cancel'
import { useState } from 'react'
import {
  Button,
  FormWithRedirect,
  required,
  SaveButton,
  SelectInput,
  TextInput,
  useNotify,
  useRefresh,
} from 'react-admin'

import { captureExceptionIfProduction } from 'helpers/utils'
import { reportIssue } from '../../api/jobs'
import { IssueTypeChoices } from '../../helpers/constants'
import { withDisableBackdropClick } from '../../helpers/withDisableBackdropClick'

export function ReportIssueButton({ record }: any) {
  const [showDialog, setShowDialog] = useState(false)
  const [loading, setLoading] = useState(false)

  const notify = useNotify()
  const refresh = useRefresh()
  const handleClick = () => setShowDialog(true)
  const handleClose = () => setShowDialog(false)

  const handleSubmit = async (values: any) => {
    setLoading(true)
    reportIssue(record.id, values)
      .then(() => {
        setShowDialog(false)
        setLoading(false)
        notify('Issue reported!', { type: 'info' })
        refresh()
      })
      .catch((error) => {
        setLoading(false)
        setShowDialog(false)
        notify(error.message, { type: 'error' })
        captureExceptionIfProduction(error)
      })
  }

  return (
    <>
      <Button onClick={handleClick} label="ra.action.create">
        <IconContentAdd />
      </Button>
      <Dialog
        fullWidth
        open={showDialog}
        onClose={withDisableBackdropClick(handleClose)}
        aria-label="Report issue"
      >
        <DialogTitle>Report Issue for Job</DialogTitle>
        <FormWithRedirect
          resource="issues"
          save={handleSubmit}
          render={({ handleSubmitWithRedirect, saving }) => (
            <>
              <DialogContent>
                <SelectInput source="type" label="Type" choices={IssueTypeChoices} validate={required()} />
                <TextInput
                  source="description"
                  label="Description (driver facing)"
                  validate={required()}
                  fullWidth
                  multiline
                />
                <TextInput source="notes" label="Internal Note" fullWidth multiline />
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleClose} disabled={loading}>
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={handleSubmitWithRedirect}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  )
}
